export const getUniqueNumberArray = (input: number[]): number[] => [
    ...new Set<number>(input),
];
